/// <reference path="../wpt.ts" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.WorkViewFilterResult";
        class WorkViewFilterResultWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("WorkViewFilterResultWidgetTypeClass.createInstance()");
                    return new WorkViewFilterResultWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("WorkViewFilterResultWidgetTypeClass._storeHtml()");
                    WorkViewFilterResultWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WorkViewFilterResultWidgetTypeClass::constructor");
                if (WorkViewFilterResultWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/WorkViewFilterResult/workview-filterresult.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.WorkViewFilterResultWidgetTypeClass = WorkViewFilterResultWidgetTypeClass;
        class WorkViewFilterResultWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._loader = null;
                this._usesDynamicTitle = null;
                this._mainDiv = null;
                this._currentFilter = null;
                this._currentConstraints = null;
                this._currentApplication = null;
                this._currentClass = null;
                this._activateIntoSlot = null;
                this._messagePanel = null;
                this._headerTitle = null;
                this._createOption = null;
                this._resultPanel = null;
                this._showFilterSpan = null;
                this._hideFilterSpan = null;
                this._dataTable = null;
                this._viewConfigFile = null;
                this._refreshTriggers = null;
                this._publishDataset = 'NONE';
                this._registerDeselection = false;
                this._reselectOnRefresh = true;
                this._lastSelectedObject = null;
                this._autoSelectThisRun = false;
                this._autoSelectMode = Widgets.DocumentAutoSelectMode.NONE;
                this._autoSelectOnHomeView = false;
                this.presentInstance = () => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = WorkViewFilterResultWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._usesDynamicTitle = true;
                    this._mainDiv = this._container.querySelector('#workViewFilterResultWidget');
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._messagePanel = this._container.querySelector('#workViewFilterResultMoreRecords');
                    this._headerTitle = this._container.querySelector('#workViewFilterResultWidgetTitle');
                    this._createOption = this._container.querySelector(".workViewFilterResultCreateObject");
                    this._resultPanel = this._container.querySelector('#workViewFilterResultHolder');
                    this._showFilterSpan = this._container.querySelector(".workViewFilterResultFilter");
                    this._hideFilterSpan = this._container.querySelector(".workViewFilterResultHideFilter");
                    let reloadOption = this._container.querySelector(".workViewFilterResultReload");
                    let sizeTable = this._container.querySelector('.widget__size-target');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    let conf = this._config;
                    if (conf.hasOwnProperty('RefreshTriggers') && conf.RefreshTriggers)
                        this._refreshTriggers = conf.RefreshTriggers;
                    else
                        this._refreshTriggers = [];
                    this._core.Functions.addDefaultsToTriggerEvents(this._refreshTriggers);
                    // if no title is configured, we are using a dynamic title
                    if (this._config.Title && this._config.Title.length > 0) {
                        this._usesDynamicTitle = false;
                    }
                    this._widgets.setTitle(this._config, this._headerTitle, "");
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslationAttribute(reloadOption, 'title', 'STR_WPT_WV_RELOAD_FILTERRESULT');
                    this._core.Helper.setElementTranslationAttribute(this._createOption, 'title', 'STR_WPT_WV_CREATE_OBJECT');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#workViewFilterResultMoreRecordsMessage'), 'STR_WPT_WV_FILTERRESULT_MAXEXCEEDED');
                    this._core.Helper.setElementTranslationAttribute(this._showFilterSpan, 'title', 'STR_WPT_WV_FILTER_RESULT');
                    this._core.Helper.setElementTranslationAttribute(this._hideFilterSpan, 'title', 'STR_WPT_HIDE_FILTER');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#workViewFilterResultLoading'), 'STR_WPT_LOADING');
                    reloadOption.addEventListener('click', this._reloadFilterResult);
                    this._createOption.addEventListener('click', this._createObjectClicked);
                    this._showFilterSpan.addEventListener('click', this._openFilterPanel);
                    this._hideFilterSpan.addEventListener('click', this._closeFilterPanel);
                    this._container.querySelector('#hideWorkViewFilterResultMoreRecordsMessage').addEventListener('click', this._hideMessage);
                    if (conf.hasOwnProperty('AutoSelectMode'))
                        this._autoSelectMode = Widgets.DocumentAutoSelectMode[conf.AutoSelectMode];
                    if (conf.hasOwnProperty('AutoSelectOnHomeView') && conf.AutoSelectOnHomeView)
                        this._autoSelectOnHomeView = true;
                    if (conf.hasOwnProperty('ReselectOnRefresh') && (conf.ReselectOnRefresh != null))
                        this._reselectOnRefresh = conf.ReselectOnRefresh;
                    if (conf.hasOwnProperty("RegisterDeselection") && (conf.RegisterDeselection == true))
                        this._registerDeselection = true;
                    let maxHeightPx = null;
                    let maxHeight = window.getComputedStyle(sizeTable).maxHeight;
                    if (maxHeight != "none") {
                        // expecting max-height set in pixels
                        maxHeightPx = parseInt(maxHeight, 10);
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using max-height: " + maxHeightPx);
                        }
                    }
                    this._dataTable = new Widgets.ComponentWvFilterResultTable(this._core, this._resultPanel, this, maxHeightPx);
                    if (conf.hasOwnProperty('InitialPageSize') && (conf.InitialPageSize != null))
                        this._dataTable.PageLength = conf.InitialPageSize;
                    if (this._publishDataset == 'INITIAL')
                        this._dataTable.VisibleDataInitialisedCallback = this._fireDatasetEvent;
                    else if (this._publishDataset == 'ALL') {
                        this._dataTable.VisibleDataInitialisedCallback = this._fireDatasetEvent;
                        this._dataTable.VisibleDataFilteredCallback = this._fireDatasetEvent;
                    }
                    this._dataTable.present();
                    if (conf.hasOwnProperty('RunFilter')) {
                        var requestFilterResult = conf.RunFilter;
                        this._runFilter(requestFilterResult);
                    }
                    this._type.instanceReady(this.getHandle());
                };
                this._runFilter = (request) => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._runFilter()");
                    this._core.Functions.showElement(this._mainDiv);
                    this._core.Functions.showElement(this._loader);
                    this._closeFilterPanel();
                    this._currentApplication = request.Application;
                    this._currentFilter = request.Filter;
                    this._currentConstraints = null;
                    this._currentClass = null;
                    let flexSearch = {
                        SearchDefinition: {
                            Type: "byfilter",
                            Terms: [
                                {
                                    Term: ">>application",
                                    Value: this._currentApplication
                                },
                                {
                                    Term: ">>filter",
                                    Value: this._currentFilter
                                }
                            ]
                        }
                    };
                    if (request.hasOwnProperty('Constraints') && request.Constraints) {
                        this._currentConstraints = request.Constraints;
                        let resultingConstraints = this._core.OBHelper.expandWorkViewConstraintMacros(request.Constraints);
                        flexSearch.SearchDefinition.Terms.push(...resultingConstraints);
                    }
                    this._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/ObjectQuery', JSON.stringify(flexSearch), this._presentFilterResultData, null, this._callErrorHandler, this._callFailedHandler);
                };
                this._presentFilterResultData = (resultData) => __awaiter(this, void 0, void 0, function* () {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._presentFilterResultData()");
                    this._core.Functions.hideElement(this._loader);
                    let filterResult = resultData.FilterResult;
                    if (filterResult.HasMoreRecords) {
                        this._core.Functions.showElement(this._messagePanel);
                    }
                    else {
                        this._core.Functions.hideElement(this._messagePanel);
                    }
                    if (this._usesDynamicTitle) {
                        this._core.Widgets.setTitle(this._config, this._headerTitle, "");
                        this._headerTitle.setAttribute('title', "");
                        if (this._currentFilter != null && this._currentFilter != undefined && this._currentFilter.length > 0) {
                            let filterLabel = this._currentFilter;
                            let appLabel = this._currentApplication;
                            let appConfig = yield this._core.Helper.getWvViewConfigForApplication(this._viewConfigFile, this._currentApplication);
                            if (appConfig) {
                                if (appConfig.hasOwnProperty('DisplayName') && appConfig.DisplayName.length > 0) {
                                    appLabel = this._core.Locale.getTranslation(appConfig.DisplayName);
                                }
                                if (appConfig.hasOwnProperty('Filters') && appConfig.Filters.length > 0) {
                                    let filterConfig = appConfig.Filters.find(f => f.Name == this._currentFilter);
                                    if (filterConfig && filterConfig.hasOwnProperty('DisplayName') && filterConfig.DisplayName.length > 0) {
                                        filterLabel = this._core.Locale.getTranslation(filterConfig.DisplayName);
                                    }
                                }
                            }
                            let infoString = filterLabel + " | " + appLabel;
                            this._core.Widgets.setTitle(this._config, this._headerTitle, infoString);
                            this._headerTitle.setAttribute('title', infoString);
                        }
                    }
                    this._currentClass = filterResult.Class.Name;
                    let classConfig = yield this._core.Helper.getWvViewConfigForClass(this._viewConfigFile, this._currentApplication, this._currentClass);
                    if (filterResult.Class.Readonly || filterResult.Class.Blocked) {
                        this._core.Functions.hideElement(this._createOption);
                    }
                    else {
                        if (classConfig != null && classConfig.Readonly) {
                            this._core.Functions.hideElement(this._createOption);
                        }
                        else {
                            this._core.Functions.showElement(this._createOption);
                        }
                    }
                    let selectionConfig = {
                        AutoSelectMode: this._autoSelectMode,
                        AutoSelectOnHomeView: this._autoSelectOnHomeView,
                        AutoSelectRowCreated: this._autoSelectRowCreated,
                        CurrentLayout: this._currentLayout,
                        LastSelectedObject: this._lastSelectedObject,
                        ObjectDeselected: this._objectDeselected,
                        PreviousObjectRowCreated: this._previousObjectRowCreated,
                        ReselectOnRefresh: this._reselectOnRefresh
                    };
                    let conf = this._config;
                    let rowClickCallback = null;
                    if (!filterResult.Class.Blocked) {
                        rowClickCallback = this._objectClicked;
                    }
                    else if (conf.hasOwnProperty('DisplayMessageForBlockedClasses') && conf.DisplayMessageForBlockedClasses) {
                        rowClickCallback = this._objectClickedButClassBlocked;
                    }
                    this._autoSelectThisRun = this._dataTable.displayFilterResult(filterResult, classConfig, selectionConfig, rowClickCallback);
                });
                this._reloadFilterResult = () => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._reloadFilterResult()");
                    let requestFilterResult = {
                        Application: this._currentApplication,
                        Filter: this._currentFilter,
                        Constraints: this._currentConstraints
                    };
                    this._runFilter(requestFilterResult);
                };
                this._createObjectClicked = () => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._createObjectClicked()");
                    let requestObject = {
                        Application: this._currentApplication,
                        Class: this._currentClass
                    };
                    let conf = this._config;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`clicked create object for class '${this._currentClass}' of application '${this._currentApplication}'`);
                    }
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.WV_CLASS_SELECTED);
                    navEvent.ActivationID = 0;
                    navEvent.PrimaryContext = requestObject;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = this._currentLayout;
                    if (conf.hasOwnProperty("LaunchLayout") && conf.LaunchLayout) {
                        if (conf.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = conf.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (conf.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(conf.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._openFilterPanel = () => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._openFilterPanel()");
                    this._core.Functions.hideElement(this._showFilterSpan);
                    this._core.Functions.showElement(this._hideFilterSpan);
                    this._dataTable.showFilterRow();
                };
                this._closeFilterPanel = () => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._closeFilterPanel()");
                    this._core.Functions.hideElement(this._hideFilterSpan);
                    this._core.Functions.showElement(this._showFilterSpan);
                    this._dataTable.hideFilterRow();
                };
                this._hideMessage = () => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._hideMessage()");
                    this._core.Functions.hideElement(this._messagePanel);
                };
                this._objectClicked = (event) => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._objectClicked()");
                    let clickedItem = event.currentTarget;
                    this._dataTable.clearRowSelection();
                    clickedItem.classList.add(Widgets.WIDGET_SELECTED_CLASS);
                    let requestObject = {
                        Application: clickedItem.getAttribute(Widgets.WV_APPLICATION_NAME_ATTRIBUTE),
                        Class: clickedItem.getAttribute(Widgets.WV_CLASS_NAME_ATTRIBUTE),
                        ObjectId: +clickedItem.getAttribute(Widgets.WV_OBJECT_ID_ATTRIBUTE)
                    };
                    this._lastSelectedObject = requestObject;
                    let conf = this._config;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`clicked object '${requestObject.ObjectId} for class '${requestObject.Class}' of application '${requestObject.Application}'`);
                    }
                    let activationType = WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_SELECTED;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, activationType);
                    navEvent.ActivationID = requestObject.ObjectId;
                    navEvent.PrimaryContext = requestObject;
                    navEvent.Slots.push(this._activateIntoSlot);
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = this._currentLayout;
                    if (conf.hasOwnProperty("LaunchLayout") && conf.LaunchLayout) {
                        if (conf.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = conf.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (conf.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(conf.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._objectClickedButClassBlocked = (event) => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._objectClickedButClassBlocked()");
                    let clickedItem = event.currentTarget;
                    this._dataTable.clearRowSelection();
                    clickedItem.classList.add(Widgets.WIDGET_SELECTED_CLASS);
                    this._core.Helper.presentWarningModal('STR_WPT_WV_BLOCKEDCLASS_MESSAGE', 'STR_WPT_WV_BLOCKEDCLASS_TITLE');
                };
                this._objectDeselected = () => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._objectDeselected()");
                    if (!this._registerDeselection)
                        return;
                    let config = this._config;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_DESELECTED);
                    navEvent.ActivationID = this._lastSelectedObject.ObjectId;
                    navEvent.PrimaryContext = this._lastSelectedObject;
                    navEvent.Slots.push(this._activateIntoSlot);
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = this._currentLayout;
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                    this._lastSelectedObject = null;
                };
                this._autoSelectRowCreated = (rowElement) => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._autoSelectRowCreated()");
                    // Allow table build to finish before evaluating click
                    if (this._autoSelectThisRun) {
                        window.setTimeout(this._processAutoSelection.bind(this, rowElement), 0);
                    }
                };
                this._previousObjectRowCreated = (rowElement) => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._previousObjectRowCreated()");
                    // Allow table build to finish before evaluating click
                    window.setTimeout(this._processAutoSelection.bind(this, rowElement), 0);
                };
                this._processAutoSelection = (rowElement) => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._processAutoSelection()");
                    let event = new Event('click');
                    rowElement.dispatchEvent(event);
                    this._autoSelectThisRun = false;
                };
                this._callFailedHandler = (json) => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._fireDatasetEvent = (data) => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass._fireDatasetEvent()");
                    if ((this._publishDataset == 'ALL') || ((this._publishDataset == 'INITIAL') && (data.ProducedBy == 'initial'))) {
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DATASET_PUBLISHED);
                        navEvent.ActivationID = 0;
                        navEvent.PrimaryContext = data;
                        navEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                };
                this.activate = (context) => {
                    this._log.info("WorkViewFilterResultWidgetInstanceClass.activate()");
                    // Don't get stuck in a loop!
                    if (!this._activationSourceValid(context))
                        return;
                    switch (context.ActivationType) {
                        case WPTNamespace.Navigation.LayoutActivationType.WV_FILTER_SELECTED:
                            this._runFilter(context.PrimaryContext);
                            break;
                        default:
                            if (this._refreshTriggers.length > 0) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("looking at refresh triggers: " + JSON.stringify(this._refreshTriggers));
                                }
                                // Loop with iterator so we can escape when necessary
                                for (let i = 0; i < this._refreshTriggers.length; i++) {
                                    let trigger = this._refreshTriggers[i];
                                    if (this._core.Functions.triggerEventMatches(trigger, context)) {
                                        this._reloadFilterResult();
                                        // Only trigger once
                                        return;
                                    }
                                    else {
                                        continue;
                                    }
                                }
                            }
                            break;
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WorkViewFilterResultWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                let conf = this._config;
                if (conf.hasOwnProperty('ActivateIntoSlot') && conf.ActivateIntoSlot) {
                    this._activateIntoSlot = conf.ActivateIntoSlot;
                }
                else {
                    this._activateIntoSlot = WPTNamespace.Utilities.PRIMARY_SLOT_KEY;
                }
                if (conf.hasOwnProperty('ViewConfiguration') && conf.ViewConfiguration) {
                    this._viewConfigFile = conf.ViewConfiguration;
                }
                else {
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (appConfig.hasOwnProperty('WorkViewViewConfiguration') && appConfig.WorkViewViewConfiguration) {
                        this._viewConfigFile = appConfig.WorkViewViewConfiguration;
                    }
                }
                if (conf.hasOwnProperty('PublishDatasets') && conf.PublishDatasets)
                    this._publishDataset = conf.PublishDatasets;
            }
        }
        WorkViewFilterResultWidgetInstanceClass.HtmlData = null;
        Widgets.WorkViewFilterResultWidgetInstanceClass = WorkViewFilterResultWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
